import { useTranslation } from '@pypestream/translations';

/**
 * The one line shown in place of a private key's contents. Both surfaces that
 * withhold a key use it — the Actions editor dialog (`actions.tsx`) and the
 * publish diff (`deploy/diff-parts.tsx`) — so the key and its fallback text
 * live here and cannot drift apart between them.
 */
const SECRET_HIDDEN_KEY = 'pro-studio/actions:editorModal.secret_hidden';

const SECRET_HIDDEN_DEFAULT =
  "Contains a private key — its contents aren't shown here.";

export const useSecretHiddenNotice = (): string => {
  const [t] = useTranslation();
  return t(SECRET_HIDDEN_KEY, { defaultValue: SECRET_HIDDEN_DEFAULT });
};
